export default class ViacepAddress {
  public cep: string = '';

  public logradouro: string = '';

  public complemento: string = '';

  public bairro: string = '';

  public localidade: string = '';

  public uf: string = '';

  public ibge: string = '';

  public gia: string = '';

  public ddd: string = '';

  public siafi: string = '';

  public numero: string = '';

  constructor(data: any = {}) {
    this.cep = data.cep || '';
    this.logradouro = data.logradouro || '';
    this.complemento = data.complemento || '';
    this.bairro = data.bairro || '';
    this.localidade = data.localidade || '';
    this.uf = data.uf || '';
    this.ibge = data.ibge || '';
    this.gia = data.gia || '';
    this.ddd = data.ddd || '';
    this.siafi = data.siafi || '';
    this.numero = data.numero || '';
  }
}
